<script>
import collapsible from '../mixins/collapsible';
import FavoriteAction from './FavoriteAction.vue';
import SubscribeAction from './SubscribeAction.vue';
import ResourceSubscribeModal from './ResourceSubscribeModal.vue';

export default {
    name: 'ResourceSidebar',
    components: {
        FavoriteAction,
        SubscribeAction,
        ResourceSubscribeModal,
    },
    mixins: [collapsible],
};
</script>
